import { Component, OnInit, Input, Output, ViewChild } from "@angular/core";
import { ZipCodeFloridaModel } from "../../zip-code-florida.model";
import { EventEmitter } from "@angular/common/src/facade/async";
import { ZipCodeFloridaService } from "../../zip-code-florida.service";
import { T2CardComponent } from "../../../../trip2-theme/components/t2-card/t2-card.component";
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: "app-zip-code-florida-create",
  templateUrl: "./create.component.html",
  styleUrls: ["./create.component.scss"],
})
export class CreateComponent implements OnInit {
  protected mode = "Add New Zip Code";
  protected data: ZipCodeFloridaModel = new ZipCodeFloridaModel();
  protected countyList: any;

  @Input() zipCodeFloridaSelected: number;
  @Output() notify: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() cancel: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild("cardZipCodeFloridaCreate") card: T2CardComponent;
  private minlenght = 5;

  constructor(
    protected service: ZipCodeFloridaService,
    private _sweetAlert: SweetAlertHelper
  ) {
  }

  /**
   * @name cancelAction
   * @description
   */
  cancelAction(event) {
    if (!event) {
      this.cancel.emit(event);
    }
    this.cancel.emit(true);
  }

  /**
   * @name saveAction
   * @description
   */
  saveAction() {
    if (this.data.Zip.length > this.minlenght) {
      this._sweetAlert.captureException('The Zip Code must not exceed 5 characters.');
      return;
    }
    this.card.viewProgressBar(true);
    if (this.zipCodeFloridaSelected === 0) {
      this.service
        .postData(this.data)
        .finally(() => {
          this.card.viewProgressBar(false);
        })
        .subscribe(
          (res) => this.sendNotify(res),
          (err) => this.notify.emit(err)
        );
    } else {
      this.service
        .putData(this.data)
        .finally(() => {
          this.card.viewProgressBar(false);
        })
        .subscribe(
          (res) => this.sendNotify(res),
          (err) => this.notify.emit(err)
        );
    }
  }

  /**
   * @name sendNotify
   * @description
   * @param data
   */
  sendNotify(data: any) {
    if (data.success) {
      this.notify.emit(data);
      this.data = new ZipCodeFloridaModel();
    }
  }

  /**
   * @name setData
   * @description
   * @param data
   */
  setData(data) {
    this.data.County = data.county;
    this.data.Zip = data.zip;
    this.data.City = data.city;
  }

  /**
   * @name onlyNumbers
   * @description Allows only numeric input for Zip Code field
   * @param event
   */
  onlyNumbers(event: KeyboardEvent) {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  }

  /**
   * @name ngOnInit
   * @description
   */
  ngOnInit() {
    if (this.zipCodeFloridaSelected !== 0) {
      this.mode = "Edit Zip Code";
      this.service
        .getZipCodeFloridaById(this.zipCodeFloridaSelected)
        .subscribe((data) => {
          this.setData(data);
          this.mode = `Edit Zip Code - ${data.zip}`;
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/zip-code-florida/components/create/create.component.ts